import templates from '../../../ui/widgets/resource-entry/templates';
import { buildNoRecordsConfig, getStartDateForData } from './schedule-five-individual-combined-elements';
import { TITLE_WIDTH, TOTAL_WIDTH, registerSummaryGridRefresher } from './schedule-five-summary-shared';

let _k_varianceGrid = null;

const createVarianceGridInternal = (data, startDate, opts = {}) => {
    const $grid = $('.grid.variance-grid');
    _k_varianceGrid?.grid?.destroy();
    $grid.empty();

    _k_varianceGrid = $grid
        .kendoResourceEntry({
            columnWidth: 120,
            dataSource: {
                schema: {
                    model: {
                        id: 'id',
                        fields: {
                            title: { editable: false, type: 'string' },
                            total: { editable: false, type: 'number' },
                        },
                    },
                },
                data: data,
            },
            staticColumns: [
                {
                    field: 'title',
                    type: 'string',
                    title: '&nbsp;',
                    width: TITLE_WIDTH,
                    editable: false,
                },
                {
                    field: 'total',
                    type: 'number',
                    template: templates.columnBased('total', 'format'),
                    title: 'Total',
                    width: TOTAL_WIDTH,
                    editable: false,
                },
            ],
            readonly: true,
            startDate: startDate,
            input: {
                type: 'columnBased',
                typeColumn: 'format',
            },
            dataBound() {
                $('.grid.variance-grid div.k-grid-footer').hide();
            },
            grid: {
                ...buildNoRecordsConfig(opts.suppressNoRecords),
            },
        })
        .data('kendoResourceEntry');
};

export const createVarianceGrid = (filters = {}) => {
    const $grid = $('.grid.variance-grid');
    const company = $grid.data('company');
    return $.getJSON('/Operations/ScheduleFiveOverview/GetVarianceRevenueTotals', { company, ...filters }).done(data => {
        const startDate = getStartDateForData(data);
        createVarianceGridInternal(data, startDate);
    });
};

export const getVarianceGrid = () => _k_varianceGrid?.grid;

export const refreshVarianceGrid = () => {
    _k_varianceGrid.grid.refresh();
};

export const initVarianceGrid = () => {
    registerSummaryGridRefresher(createVarianceGrid);
    createVarianceGridInternal([], new Date(), { suppressNoRecords: true });
    kendo.ui.progress($('.s5-variance-wrap'), true);

    return Promise.all([createVarianceGrid()])
        .then(() => {
            kendo.ui.progress($('.s5-variance-wrap'), false);
        })
        .catch(() => {
            kendo.ui.progress($('.s5-variance-wrap'), false);
        });
};
